export class FilterView {
    constructor(
        public fromDate: string,
        public toDate: string,
        public documentTypesIds: Array<string>,
        public airlinesIds: Array<string>,
        public countriesIds: Array<number>,
        public currencyId: number,
        public currencyCode: string,
        public agentsIds: Array<number>,
        public agentsGroupsIds: Array<number>,
        public contractsIds: Array<number>,
        public overCommission: boolean
    ) { }
}

export class FilterViewComplete {
    constructor(
        public fromDate: any,
        public toDate: any,
        public airlines: any,
        public documentTypes: any,
        public countries: any,
        public currency: any,
        public agents: any,
        public agentsGroups: any,
        public contracts: any,
        public overCommission: boolean
    ) { }
}
